import { Component } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from 'src/environments/environment';
import { EurocodeRecord } from '../../domain/eurocode';
import { LazyLoadEvent } from 'primeng/api';
import { debounceTime, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-admin-eurocode',
  templateUrl: './admin-eurocode.component.html',
  styleUrl: './admin-eurocode.component.scss'
})
export class AdminEurocodeComponent {
  data$: Observable<any>;

  codes: EurocodeRecord[] = [];
  totalRecords: number = 0;
  loading: boolean = true;
  rows: number = 10;

  statusOptions = [
    { label: 'ALL', value: 'ALL' },
    { label: 'TBC', value: 'TBC' },
    { label: 'CFD', value: 'CFD' },
    { label: 'ERR', value: 'ERR' },
    { label: 'DEL', value: 'DEL' },
  ];
  
  ngOnInit(): void {
    const storedQuery = localStorage.getItem('eurocodeQuery');
    const storedQueryDate = localStorage.getItem('eurocodeQueryDate');
    const storedStatus = localStorage.getItem('eurocodeStatus');
    const storedStatusDate = localStorage.getItem('eurocodeStatusDate');

    if (storedQuery && storedQueryDate) {
      const queryDate = new Date(storedQueryDate);
      const now = new Date();
      const diffInHours = (now.getTime() - queryDate.getTime()) / (1000 * 60 * 60);
      if (diffInHours < 2) {
        this.query = storedQuery;
      }
    }

    if (storedStatus && storedStatusDate) {
      const statusDate = new Date(storedStatusDate);
      const now = new Date();
      const diffInHours = (now.getTime() - statusDate.getTime()) / (1000 * 60 * 60);
      if (diffInHours < 2) {
        this.selectedStatus = storedStatus;
      }
    }
    //this.loadCodes({ first: 0, rows: this.rows });
  }

  set query(value: string) {
    this._query = value;
    localStorage.setItem('eurocodeQuery', value);
    localStorage.setItem('eurocodeQueryDate', new Date().toISOString());
  }

  get query(): string {
    return this._query;
  }

  private _query: string = '';

  set selectedStatus(value: string) {
    this._selectedStatus = value;
    localStorage.setItem('eurocodeStatus', value);
    localStorage.setItem('eurocodeStatusDate', new Date().toISOString());
  }

  get selectedStatus(): string {
    return this._selectedStatus;
  }

  private _selectedStatus: string = '';



  constructor(private adminService: AdminService, private router: Router) {}
  loadCodes(event: LazyLoadEvent): void {

    this.loading = true;
    const page = 1+(event.first! / event.rows!);
    const size = event.rows!;

    this.adminService.getEurocodes(page, size, this.query, this.selectedStatus).subscribe(
      response => {
        this.codes = response.Data;
        this.totalRecords = response.TotalRecords;
        this.loading = false;
      },
      error => {
        console.error('Error fetching codes', error);
        this.loading = false;
      }
    );
  }


  goToView(id: number) {
    window.location.href =  environment.localUrl +`Home/Wizard?eurocode=${id}&context=VIEW`;
  }

  goToEdit(id: number) {
    window.location.href =  environment.localUrl +`Home/Wizard?eurocode=${id}&context=EDIT`;
  }

  goBack(id: number) {
    this.router.navigate(['admin-dashboard']);
  }

  goToCopy(id: number) {
    window.location.href = environment.localUrl + `Home/Wizard?eurocode=${id}&context=COPY`;
  }
  goToNew() {
    window.location.href = environment.localUrl + `Home/Wizard?eurocode=new`;
  }

}
